export function formatRewardAmount(amount: string, scale: number, symbol: string): string {
  const neg = amount.startsWith("-");
  const digits = (neg ? amount.slice(1) : amount).replace(/\D/g, "") || "0";
  const padded = digits.padStart(scale + 1, "0");
  const body = scale > 0 ? `${padded.slice(0, -scale)},${padded.slice(-scale)}` : padded.replace(/^0+(?=\d)/, "");
  return `${neg ? "−" : ""}${body} ${symbol}`.trim();
}

export function ledgerKindLabel(kind: string): string {
  switch (kind) {
    case "EARN":
      return "Начисление";
    case "ISSUE":
      return "Выдано";
    case "ADJUST":
      return "Корректировка";
    case "ZERO_ADJUST":
      return "Обнуление";
    default:
      return kind;
  }
}

export const REWARD_ICONS = ["₽", "R$", "⭐", "🪙", "🎮", "🧸", "🌸"] as const;
